module.exports = __webpack_public_path__ + "static/media/simpsonSaysLogo.2bb50d02.png";